import script from "./friendCirclePermission.vue?vue&type=script&setup=true&lang=js"
export * from "./friendCirclePermission.vue?vue&type=script&setup=true&lang=js"

import "./friendCirclePermission.vue?vue&type=style&index=0&id=22c05c44&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c05c44"]])

export default __exports__